var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tk-detail-audio"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"tk-detail-audio-item"},[_c('div',{on:{"click":function($event){_vm.playAudio(item.src,item.id)}}})])}))}
var staticRenderFns = []

export { render, staticRenderFns }